/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
} from '@material-ui/core';
import { Close, MoreHoriz } from '@material-ui/icons';
import { deleteTeam, getTeamInfoById } from '@webapps/business';
import {
  Button,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Modal from 'components/Modal';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import NewTeams from './NewTeams';
import Information from 'components/Icons/Information';

const ActionTeam = ({ from, id, nbrStudent, refetch, addStudent }) => {
  const { classes, css, theme: { spacing }, } = useStyles(styles);
  const history = useHistory();

  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openCreateTeam, setOpenCreateTeam] = useState(false);
  const [openDeleteTeam, setOpenDeleteTeam] = useState(false);
  const { addToast } = useToast();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { data: team = {} } = useQuery(getTeamInfoById, {
    key: ['team', id],
    variables: { id },
  });
  const handleOpenCreateTeam = () => {
    setOpenCreateTeam(true);
  };

  const handleCloseCreateTeam = () => {
    setOpenCreateTeam(false);
  };

  const handleOpenDeleteTeam = () => {
    setOpenDeleteTeam(true);
  };

  const handleCloseDeleteTeam = () => {
    setOpenDeleteTeam(false);
  };

  const {
    isLoading: isLoadingDeleteTeam,
    isSuccess: isSuccessDeleteTeam,
    mutateAsync: mutateDeleteTeam,
  } = useMutation(deleteTeam);

  const handleDeleteTeam = () => {
    mutateDeleteTeam({
      id,
    });
  };

  useEffect(() => {
    if (isSuccessDeleteTeam) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      handleCloseDeleteTeam();
      handleClose();
      if (from === 'item') {
        history.goBack();
      }
    }
  }, [isSuccessDeleteTeam]);

  const { params, push } = useRouter();

  const { id: idParam } = params;

  const goToStudentListExclu = () => {
    push(ROUTES_PATH.BUSINESS_STUDENT_EXCLUD, { params: { id: idParam } });
  };

  const goToStudentListAbandoned = () => {
    push(ROUTES_PATH.BUSINESS_STUDENT_ABANDONED, { params: { id: idParam } });
  };

  if(team?.defaultTeam){
    return (<div></div>);
  }

  return (
    <div>
      <IconButton
        onClick={handleClick}
        size="small"
        aria-controls='candidature-menu'
        aria-haspopup="true"
        aria-expanded='true'
        className={css({ margin: '0px 3px', alignSelf: 'baseline', borderRadius: '20px', border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF', width: '26px', display: 'flex', justifyContent: 'center', height: '26px', alignItems: 'center', cursor: 'pointer' })}>
        <MoreHoriz style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="simple-menu"
        keepMounted
        onClose={handleClose}
        open={Boolean(anchorEl)}
        transformOrigin={{ horizontal: 'left', vertical: -50 }}
        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
      >
        <MenuItem disableRipple disableFocusRipple onClick={handleOpenCreateTeam}>Modifier le nom</MenuItem>
        <MenuItem disableRipple disableFocusRipple onClick={handleOpenDeleteTeam}>Supprimer l'équipe</MenuItem>
        {/*<MenuItem disableRipple disableFocusRipple onClick={addStudent}>Inviter un apprenant</MenuItem>
         <MenuItem onClick={goToStudentListExclu}>
          Etudiant(s) supprimé(s)
        </MenuItem>
        <MenuItem onClick={goToStudentListAbandoned}>
          Etudiant(s) abandonné(s)
        </MenuItem> */}
      </Menu>
      <Modal
        nbStep={1}
        onCancel={handleCloseCreateTeam}
        open={openCreateTeam}
        step={1}
        title="Formulaire pour modifier le nom de votre équipe"
        // subTitle="Cette modification est un détail d’affichage pour votre compte"
        withStep={false}
      >
                 <div className={css({display: 'flex', flexDirection: 'row'})}>
          <span>
          <Information className={css({color:'#0060F9', height: 20, width: 20, marginRight: 10})}/>
          </span>
          <div className={css({fontSize: 14, color:'rgba(0, 0, 0, 0.87)'})}>
          Cette modification est un détail d’affichage pour votre compte
          </div>
        </div>
        <NewTeams close={handleCloseCreateTeam} data={team} refetch={refetch} />
      </Modal>
      <Dialog
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 45, 117, 0.6)',
          },
        }}
        classes={{
          paperScrollPaper: css({
            width: '100%',
            maxWidth: 500,
            borderRadius: 10,
            position: 'relative',
            overflow: 'visible',
          }),
        }}
        onClose={handleCloseDeleteTeam}
        open={openDeleteTeam}
      >
        <IconButton
          className={css({
            position: 'absolute',
            background: '#045ff9',
            color: 'white',
            top: -10,
            right: -10,
            '&:hover': {
              background: '#045ff9',
              color: 'white',
            },
          })}
          onClick={handleCloseDeleteTeam}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
        <DialogTitle
          className={css({ background: '#045ff9', borderTopLeftRadius: 10 })}
          id="alert-dialog-title"
        >
          Suppression de l'équipe
        </DialogTitle>
        <DialogContent>
          {nbrStudent > 0
            ? 'Cette équipe contient déjà des étudiants'
            : 'Êtes-vous sûr de vouloir supprimer ?'}
        </DialogContent>
        <DialogActions>
          {nbrStudent > 0 ? (
            <Button
              color="primary"
              onClick={handleCloseDeleteTeam}
              variant="outlined"
            >
              Fermer
            </Button>
          ) : (
            <>
              <Button
                color="primary"
                onClick={handleCloseDeleteTeam}
                variant="outlined"
              >
                Annuler
              </Button>
              <Button
                autoFocus
                color="primary"
                disabled={isLoadingDeleteTeam}
                onClick={handleDeleteTeam}
                variant="contained"
              >
                Supprimer
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

const styles = ({ spacing }) => ({
  buttonAction: {
    // alignItems: 'center',
    // borderRadius: '10.0px',
    // padding: spacing(0.5),
  },
});

ActionTeam.propTypes = {
  id: PropTypes.number.isRequired,
  refetch: PropTypes.func,
  nbrStudent: PropTypes.number,
  from: PropTypes.string,
};

export default ActionTeam;
